import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { FaFileExcel, FaFilePdf, FaFileZipper, FaFileWord } from 'react-icons/fa6';
const fileToTypeToIconMapping = {
    'application/pdf': _jsx(FaFilePdf, { color: '#E53935', size: '100%' }),
    'application/msword': _jsx(FaFileWord, { color: '#2B579A', size: '100%' }),
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': _jsx(FaFileWord, { size: 56, color: '#2B579A' }),
    'application/vnd.ms-excel': _jsx(FaFileExcel, { color: '#217346', size: '100%' }),
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': _jsx(FaFileExcel, { color: '#217346', size: '100%' }),
    'application/zip': _jsx(FaFileZipper, { color: '#F9A825', size: '100%' }),
    'application/x-zip-compressed': _jsx(FaFileZipper, { color: '#F9A825', size: '100%' }),
    'application/x-rar-compressed': _jsx(FaFileZipper, { color: '#F9A825', size: '100%' }),
    'application/vnd.rar': _jsx(FaFileZipper, { color: '#F9A825', size: '100%' }),
    'application/x-7z-compressed': _jsx(FaFileZipper, { color: '#F9A825', size: '100%' }),
};
export const UploadedFilePreview = ({ link, type, file, onDeleteFile, sx }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (_jsx(Tooltip, { title: file.original_name, arrow: true, children: _jsxs(Box, { onMouseEnter: () => {
                setIsHovered(true);
            }, onMouseLeave: () => {
                setIsHovered(false);
            }, sx: [() => ({ position: 'relative' }), ...(Array.isArray(sx) ? sx : [sx])], children: [(type === null || type === void 0 ? void 0 : type.startsWith('image/')) && (_jsx(Box, { component: 'img', src: link, style: { objectFit: 'contain', borderRadius: '8px', width: '100%', height: '100%' } })), fileToTypeToIconMapping[type], isHovered && (_jsx(IconButton, { onClick: () => {
                        onDeleteFile(file.id);
                    }, sx: () => ({
                        position: 'absolute',
                        top: '-12px',
                        right: '-12px',
                        backdropFilter: 'blur(2px)',
                        p: '4px',
                    }), children: _jsx(CloseIcon, { fontSize: 'small' }) }))] }) }, file.id));
};
